export const LVN_COMPETENCY_ITEMS = [
    // Header
    {
        id: 0,
        type: 'header',
        title: "Clinical Competency Program",
        subtitle: "INITIAL COMPETENCY ASSESSMENT SKILLS CHECKLIST—LICENSED PRACTICAL/VOCATIONAL NURSE",
        company: "INFINITE HOME HEALTH, INC"
    },

    // Page 1: Administrative/Documentation
    {
        id: 1,
        type: 'section',
        title: "A. Demonstrates ability to process paperwork and associated functions necessary to facilitate:",
        competencies: [
            {
                category: "1. Assess patient response to treatment"
            },
            {
                category: "2. Transfer of Patient"
            },
            {
                category: "3. Attends Case Conference"
            },
            {
                category: "4. Adheres to POC"
            },
            {
                category: "5. Performs services as ordered"
            },
            {
                category: "6. Reports and documents key information to physician, DC planner, Case Manager, pharmacist, supervisor"
            },
            {
                category: "7. Communicates/coordinates as appropriate with other team members"
            },
            {
                category: "8. Coordinates community resources"
            },
            {
                category: "9. Documents according to POC",
                items: [
                    "a. Medicare guidelines for documentation",
                    "b. Corrections to the clinical record",
                    "c. Accident/incident reports",
                    "d. Clinical notes, flow charts"
                ]
            },
            {
                category: "10. Other",
                items: [
                    "a. HME requisition and management",
                    "b. Supply requisition and management"
                ]
            }
        ]
    },

    // Page 2: Review of Systems - Pulmonary & Cardiovascular
    {
        id: 2,
        type: 'section',
        title: "B. Review of Systems: Demonstrates ability to obtain and document appropriate age specific history/assessment for patients in the following categories:",
        competencies: [
            {
                category: "1. Pulmonary System",
                items: [
                    "a. Pulmonary Assessment",
                    "b. Tracheostomy care",
                    "c. Oxygen administration",
                    "d. Pharyngeal suction",
                    "e. Use of oral/nasal inhalers",
                    "f. Oximeter",
                    "g. CPAP",
                    "h. Oxygen mask, nasal cannula, concentrator, portable oxygen",
                    "i. Airway insertion",
                    "j. SVN/Nebulizer treatment",
                    "k. Home ventilator management",
                    "l. Foreign body airway obstruction",
                    "m. Breathing exercises/incentive spirometry",
                    "n. Other"
                ]
            },
            {
                category: "2. Cardiovascular System",
                items: [
                    "a. Cardiovascular assessment",
                    "b. Pulses (apical, radical, femoral, pedal)",
                    "c. Edema assessment and management",
                    "d. Supine and orthostatic blood pressure",
                    "e. NTG use, inhaler use",
                    "f. CPR",
                    "g. Energy conservation techniques",
                    "h. Other"
                ]
            }
        ]
    },

    // Page 3: Neurologic & Gastrointestinal Systems
    {
        id: 3,
        type: 'section',
        title: "B. Review of Systems (continued):",
        competencies: [
            {
                category: "3. Neurologic System",
                items: [
                    "a. Neurologic assessment",
                    "b. Aphasia care",
                    "c. Mental status exam",
                    "d. Seizure precautions",
                    "e. Spinal cord injuries care",
                    "f. Head injury care",
                    "g. Other"
                ]
            },
            {
                category: "4. Gastrointestinal System",
                items: [
                    "a. Gastrointestinal assessment",
                    "b. NG tube insertion/care",
                    "c. Jejunostomy tube care",
                    "d. Gastrostomy tube care",
                    "e. Enteral feedings",
                    "f. Suction machine(s)",
                    "g. Ostomy care",
                    "h. Dysphagia precautions",
                    "i. Impaction removal",
                    "j. Enema",
                    "k. Bowel training",
                    "l. Other"
                ]
            }
        ]
    },

    // Page 4: Genitourinary & Integumentary Systems
    {
        id: 4,
        type: 'section',
        title: "B. Review of Systems (continued):",
        competencies: [
            {
                category: "5. Genitourinary System",
                items: [
                    "a. GU assessment",
                    "b. Urinary catheterization insertion and care (male and female)",
                    "c. Irrigation of catheters",
                    "d. Obtaining specimens",
                    "e. Removal of urinary catheter",
                    "f. Care of supra-pubic catheter",
                    "g. Care of urostomy",
                    "h. Bladder training",
                    "i. Nephrostomy tubes",
                    "j. Knowledge of types of catheters and indications for use (straight, indwelling, condom)",
                    "k. Ileostomy care",
                    "l. Incontinence care",
                    "m. GU post op care",
                    "n. Other"
                ]
            },
            {
                category: "6. Integumentary/Wounds/Dressings",
                items: [
                    "a. Assessment of skin/wound",
                    "b. Measurement of wounds",
                    "c. Wound irrigation",
                    "d. Wet to dry dressing(s)",
                    {
                        text: "e. Decubitis care:",
                        subItems: [
                            "1. Assessment and staging",
                            "2. Prevention",
                            "3. Various treatments (hydrocollid, calcium alginate, transparent films)",
                            "4. Documentation/pictures"
                        ]
                    },
                    "f. Ace wrap, cast care, compresses",
                    "g. Hemovac",
                    "h. Sterile dressing change",
                    "i. Suture/staple removal"
                ]
            }
        ]
    },

    // Page 5: Musculoskeletal, Pain Management, Metabolic
    {
        id: 5,
        type: 'section',
        title: "B. Review of Systems (continued):",
        competencies: [
            {
                category: "7. Musculoskeletal System",
                items: [
                    "a. Assessment",
                    "b. Range of motion (ROM)",
                    "c. TED hose",
                    "d. Total knee care",
                    "e. Total hip care",
                    "f. Cast assessment and care",
                    {
                        text: "g. Devices:",
                        subItems: [
                            "1. Walker",
                            "2. Wheelchair",
                            "3. Transfer board",
                            "4. Hoyer lift"
                        ]
                    },
                    "h. Pain assessment",
                    "i. Transfers",
                    "j. Other"
                ]
            },
            {
                category: "8. Metabolic:",
                items: [
                    "a. Assessment",
                    {
                        text: "b. Diabetic assessment and teaching:",
                        subItems: [
                            "1. Insulin types and teaching",
                            "2. Use, care and teaching of glucose monitoring system",
                            "3. Diet, exercise and sick day teaching",
                            "4. Signs and symptoms of Hypo-Hyperglycemic reactions",
                            "5. Foot and skin care"
                        ]
                    },
                    "c. Coumadin therapy",
                    "d. Other"
                ]
            }
        ]
    },

    // Page 6: Behavioral Health & Miscellaneous Skills
    {
        id: 6,
        type: 'section',
        title: "B. Review of Systems (continued):",
        competencies: [
            {
                category: "9. Behavioral Health:",
                items: [
                    "a. Assessment",
                    "b. Suicide precautions",
                    "c. Psychotropic drugs",
                    "d. Care of the demented patient",
                    "e. Other"
                ]
            },
            {
                category: "10. Miscellaneous Skills",
                items: [
                    "a. Vital signs",
                    "b. Intake and output",
                    "c. Caring for immuno-compromised patients",
                    "d. eye/ear irrigation",
                    "e. Post mortem care",
                    "f. Collection, labeling and delivering laboratory specimens (blood, urine, sputum, wound, stool)"
                ]
            }
        ]
    },

    // Page 7: Medication Administration & Infection Control
    {
        id: 7,
        type: 'section',
        title: "C. Medication Administration & Infection Control:",
        competencies: [
            {
                category: "C. Medication Administration: Demonstrates ability to administer, monitor and document medications for patients.",
                items: [
                    {
                        text: "1. Medication Administration techniques",
                        subItems: [
                            "a. Oral",
                            "b. Intra muscular",
                            "c. Subcutaneous",
                            "d. Suppositories",
                            "e. Ear, eye, nose drops",
                            "f. Heparin administration",
                            "g. Insulin administration, site rotation",
                            "h. Assessment for side effects, adverse reactions, therapeutic response"
                        ]
                    }
                ]
            },
            {
                category: "D. Infection Control:",
                items: [
                    "1. Hand washing technique",
                    "2. Aseptic technique",
                    "3. Proper bag technique",
                    "4. Safe needle technique",
                    "5. Personal protective equipment",
                    "6. Exposure control plan",
                    "7. TB exposure control plan",
                    "8. Reporting of infections for patient and personnel",
                    "9. Standard precautions"
                ]
            }
        ]
    },

    // Page 8: Equipment, Safety & Patient Education
    {
        id: 8,
        type: 'section',
        title: "E. Equipment, Safety & Patient Education:",
        competencies: [
            {
                category: "E. Equipment:",
                items: [
                    {
                        text: "1. Displays knowledge of the following:",
                        subItems: [
                            "a. Electric bed",
                            "b. Special beds",
                            "c. Alternating pressure mattress",
                            "d. Infusion pumps",
                            "e. Ambulatory infusion devices"
                        ]
                    },
                    {
                        text: "2. Home Glucose Monitoring:",
                        subItems: [
                            "a. Verbalizes purpose of test",
                            "b. Specimen collection",
                            "c. Instrument calibration",
                            "d. Quality control process",
                            "e. Test correctly performed and interpreted"
                        ]
                    },
                    "3. Other"
                ]
            },
            {
                category: "F. Safety:",
                items: [
                    "1. Restraints, indications and policy",
                    "2. Fire extinguishers",
                    "3. Emergency preparedness",
                    "4. Hazardous materials",
                    "5. Assessment of patient safety risks and home safety"
                ]
            },
            {
                category: "G. Patient Education:",
                items: [
                    "1. Determine patient and family learning needs",
                    "2. Sets measurable objectives",
                    "3. Develops/implements teaching plan",
                    "4. Evaluates effectiveness of teaching",
                    "5. Revises teaching plan based on patient needs",
                    "6. Documents response to teaching",
                    {
                        text: "7. Provides instruction in the following:",
                        subItems: [
                            "a. Emergency care",
                            "b. Diet and nutrition"
                        ]
                    }
                ]
            }
        ]
    },

    // Page 9: Comments & Signatures
    {
        id: 9,
        type: 'signature',
        title: "Comments & Signatures",
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "employeeDate", inputType: "date" },
            { label: "Supervisor Signature", name: "supervisorSignature" },
            { label: "Date", name: "supervisorDate", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor1Signature" },
            { label: "Date", name: "preceptor1Date", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor2Signature" },
            { label: "Date", name: "preceptor2Date", inputType: "date" },
            { label: "Preceptor(s)", name: "preceptor3Signature" },
            { label: "Date", name: "preceptor3Date", inputType: "date" }
        ]
    },

    // Footer
    {
        id: 10,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];

export const LVN_JOB_DESCRIPTION_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Description",
        position: "Licensed Vocational Nurse",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Qualifications Section
    {
        id: 1,
        type: 'section',
        title: "QUALIFICATIONS:",
        list: [
            "Is currently a licensed Vocational Nurse in the State of California.",
            "Has at least one-year experience as a professional nurse.",
            "Has excellent clinical judgment, knowledge of current nursing practices, observation, and communication skills.",
            "Current CPR Certification.",
            "Current and satisfactory report on pre-employment physical examination including Mantoux TB Test or chest X-ray as required by Agency policies and procedures.",
            "Able to walk, bend, stoop, and lift objects weighing up to 25 lbs.",
            "Is fluent in English.",
            "Is self-directed and able to work with little supervision and has good organizational skills.",
            "Must be a licensed driver with an automobile that is insured in accordance with state and/or organizational requirements and is in good working order.",
            "Is able to use professional judgment in reporting and seeking assistance from both peers and supervisors."
        ]
    },
    // 2: Essential Duties and Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL DUTIES AND RESPONSIBILITIES:",
        text: "The following is representation of the major duties and responsibilities of this position. The Agency will make reasonable accommodations to allow otherwise qualified applicants with disabilities to perform essential functions.",
        duties: [
            "Contributes to the development of a plan of nursing action based on existing problems, expected patient response, and the Plan of Care.",
            "Performs duties consistent with the Vocational Nursing Practice Act.",
            "Implements safe, therapeutic care of patients with overt needs in supervised / controlled situations as initiated in the Plan of Care by the physician in consultation with the Case Manager/RN and the interdisciplinary team.",
            "Utilizes resources (patient, family, staff, outside personnel, agencies/organizations) to contribute to the Plan of Care.",
            "Maintains current knowledge and skills for documenting care to meet Regulatory and third party payer requirements. Prepares documentation and clinical/progress notes. Documents clearly and concisely, using proper notation and Agency abbreviations. Submits all documentation within the timelines established by the Agency.",
            "Explains test, procedures, disease process, and provides other health education to patient, family, and/or caregiver. Documents patient/family/caregiver response to care and teaching.",
            "Notifies the patient's attending physician, dentist or podiatrist and other professional persons and responsible staff of significant changes in the patient's condition. \"Significant changes\" include those changes that suggest the need to modify or develop a plan of treatment or plan of care.",
            "May teach basic patient care to ancillary personnel and CHHAs.",
            "Participates in coordination of home health services, appropriately reporting the need for other disciplines to the case manager and/or clinical supervisor.",
            "Reports on the patient's condition and changing patient status to the Case Manager and/or clinical supervisor.",
            "Regularly attends and participates in scheduled case conferences, staff meetings and Agency in-services.",
            "Attends and/or participates in Clinical Record Reviews and other Quality Improvement functions as directed by supervisor.",
            "Prevents spread of infection and disease by proper disposal of contaminated materials and by adhering to Standard Precautions.",
            "Maintains/conserves confidentiality of patient and Agency information at all times.",
            "Regularly assesses own nursing skills and educational needs to meet the nursing care requirements of patients assigned for care. Upgrades professional skills and attends in-services and continuing education classes as needed.",
            "Provides those services requiring nursing skills in accordance with the plan of treatment of plan of care.",
            "Educates and instructs the patient, patient's family, or staff as required. Teaching patient information is limited to that which is outlined in and consistent with the licensed Vocational Nurse Practice Act.",
            "Assists the patient in learning appropriate self-care techniques.",
            "Assists the physician and registered nurse in performing specialized procedures. Prepares equipment and materials for treatments observing aseptic technique as required.",
            "Conforms to all Agency policies and procedures."
        ]
    },
    // 3: Signature Block
    {
        id: 3,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    }
];
